module.exports = "hls/videos/400_KMSAT15_2022_Cybercrime_Strategies-Ransomware/video.m3u8"